__webpack_require__.p = "/e_commerce/";